module.exports = __webpack_public_path__ + "img/other-link-icon.6ec340bb.svg";